import { Auth } from 'aws-amplify';
import DeviceUUID from "device-uuid";

const getUserInfo = async () => {
    try {
        return await Auth.currentSession()
    } catch (error) {
        return null;
    }
}

// const isEsxpir = async () => {
//     const user = await getUserInfo();
// }

const isValid = async () => {
    const user = await getUserInfo()
    return user ? user.isValid() : false;
    
}

const isValidNormal = () => {
    const local = localStorage.getItem("userInfo");
    if(local){
        return true;
    }
    // return (async () => {
    //     try{
    //         return (await getUserInfo()).isValid()
    //     } catch(error){
    //         console.log(error);
    //         return false;
    //     }
    // })();
}

const getUserInfoNormal = () => {
    try {
        const localData = localStorage.getItem("userInfo");
        if (localData) {
            const userInfo = JSON.parse(localData);
            if (userInfo && userInfo.username)
                return userInfo.username
        }

    } catch (error) {
        return null
    }
}

const DeviceId = () => new DeviceUUID.DeviceUUID().get()


export default { getUserInfo, isValid, getUserInfoNormal, isValidNormal, DeviceId };